import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import axios from 'axios'; // Import axios
import "../styles/SignUp.css";
import "../styles/SetPassword.css";

const SetPassword = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const oobCode = queryParams.get("oobCode");

  // ✅ Grab email from search params (for reset or new signup flow)
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  useEffect(() => {
    // Check if oobCode exists and perform any necessary validation (e.g., on page load)
    if (!oobCode) {
      setError('Invalid or missing reset link.');
    }
  }, [oobCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      if (oobCode) {
        // This is the reset password flow
        await resetPassword();
      } else {
        // This is the signup password set flow
        alert("Password successfully set for " + email);
        navigate("/login");
      }
    } catch (err) {
      setError("Something went wrong: " + err.message);
    }
  };

  const resetPassword = async () => {
    try {
      const response = await axios.post("http://localhost:5001/reset-password", {
        oobCode,   // Use oobCode from query params for reset
        newPassword: password,
      });

      if (response.data.success) {
        setSuccess(true);
        alert("Password successfully reset!");
        navigate("/login"); // Redirect to login page after success
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred during password reset.');
    }
  };

  return (
    <div className="setpassword-container">
      {/* Reuse Left Container from SignUp */}
      <div className="setpassword-left">
        <img src="/log-img.png" alt="Illustration" className="signup-image" />
        <img src="/star-icon.svg" alt="Star Icon" className="star-icon star-icon-top" />
        <img src="/blue-star-icon.svg" alt="Blue Star" className="star-icon star-icon-bottom" />
        <div className="white-circle"></div>
        <div className="setpassword-badge track">
          <img src="/track-icon.svg" alt="Track Icon" />
          <p>Track & Manage <br />document on the go!</p>
        </div>
        <div className="white-circle-bottom"></div>
        <div className="white-circle-bottom-right"></div> 
        <div className="white-circle-bottom-right-up"></div> 
        <div className="setpassword-badge speed">
          <img src="/speed-icon.svg" alt="Speed Icon" />
          <p>Gain speed with <br/>your document delivery 🚀</p>
        </div>
        <div className="setpassword-badge dispatch">
          <img src="/dispatch-icon.svg" alt="Dispatch Icon" />
          <p>Dispatch your Cheques <br />from anywhere</p>
        </div>
      </div>

      {/* Right Section - New Password */}
      <div className="setpassword-right">
        <div className="setpassword-wrapper">
          <div className="setpassword-card">
            <h2 className="setpassword-title">{oobCode ? 'Reset Your Password' : 'Set a New Password'}</h2>
            <p className="setpassword-subtext">
              {email ? `Setting new password for ${email}` : "Because a forgotten password is not the end of the world"}
            </p>

            <form onSubmit={handleSubmit}>
              {oobCode && (
                <div className="set-input-group">
                  <img src="/user-icon.svg" alt="User" className="input-icon" />
                  <input
                    type="text"
                    placeholder="User ID"
                    value={email} // Use the email from query params
                    disabled // User ID is not needed for reset, only oobCode is
                    required
                  />
                </div>
              )}

              <div className="set-input-group">
                <img src="/lock-icon.svg" alt="Lock" className="input-icon" />
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <img
                  src={passwordVisible ? "/hide-icon.svg" : "/show-icon.svg"}
                  alt="Toggle visibility"
                  className="toggle-icon"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                />
              </div>

              <div className="set-input-group">
                <img src="/lock-icon.svg" alt="Lock" className="input-icon" />
                <input
                  type={confirmVisible ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <img
                  src={confirmVisible ? "/hide-icon.svg" : "/show-icon.svg"}
                  alt="Toggle visibility"
                  className="toggle-icon"
                  onClick={() => setConfirmVisible(!confirmVisible)}
                />
              </div>

              <button className="setpassword-button" type="submit">{oobCode ? 'Reset Password' : 'Submit'}</button>
            </form>

            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">Password reset successfully!</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
